import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
        <Typography component="h1" variant="h4" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Você não tem permissão para acessar esta página.
          Por favor, faça login com uma conta que tenha as permissões necessárias.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/login')}
          sx={{ mt: 2 }}
        >
          Voltar para o Login
        </Button>
      </Box>
    </Container>
  );
} 